/**
 * Frases que a lista e o cadastro montam a partir do resumo calculado pelo servidor. Nenhuma regra
 * da norma mora aqui: a classe, o motivo e as contagens chegam prontos (D10).
 */
import type { FlammableClassification, FlammableInstallationSummary } from '../../../types/flammableInstallation';

const decimal = (milesimos: number): string =>
  (milesimos / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 3 });

/** "60 m³ de líquidos · 2 t de gás"; vazio quando nada foi cadastrado. */
export const capacidadesEmTexto = (summary: FlammableInstallationSummary): string => {
  const partes: string[] = [];
  if (summary.capacities.gasMilesimos > 0) partes.push(`${decimal(summary.capacities.gasMilesimos)} t de gás`);
  if (summary.capacities.liquidosMilesimos > 0) {
    partes.push(`${decimal(summary.capacities.liquidosMilesimos)} m³ de líquidos`);
  }
  return partes.join(' · ');
};

export const produtosEmTexto = (quantidade: number): string =>
  `${quantidade} ${quantidade === 1 ? 'produto' : 'produtos'}`;

/** Por que a classe saiu assim, na voz de quem lê ("Classe I, pela atividade"). */
export const motivoDaClasse = (classificacao: FlammableClassification): string => {
  switch (classificacao.reason) {
    case 'ATIVIDADE':
      return 'pela atividade';
    case 'CAPACIDADE_GAS':
      return 'pela capacidade de gás';
    case 'CAPACIDADE_LIQUIDOS':
      return 'pela capacidade de líquidos';
    case 'MAIOR_GRADACAO':
      return 'pela maior das duas capacidades';
    case 'SEM_DADOS':
      return 'cadastre os produtos';
  }
};
